// extracted by mini-css-extract-plugin
module.exports = {"jurneyFootnotes":"_73afd29","mainContent":"_f3905e7"};